import request from '@/utils/request'

// 订单分页列表
export function getOrderList(params) {
  return request({ url: '/api/order/list', method: 'get', params })
}

// 订单详情
export function getOrderDetail(id) {
  return request({ url: `/api/order/detail/${id}`, method: 'get' })
}

// 导出订单列表（Excel）
export function exportOrderList(params) {
  return request({ url: '/api/order/export', method: 'get', params, responseType: 'blob' })
}
